import { render, staticRenderFns } from "./oauth1.vue?vue&type=template&id=4fa67a4c"
import script from "./oauth1.vue?vue&type=script&lang=js"
export * from "./oauth1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports